import { render } from "./AdView.vue?vue&type=template&id=65db84b7"
import script from "./AdView.vue?vue&type=script&lang=js"
export * from "./AdView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__